/* eslint-disable max-len */
import React, { useEffect } from 'react'
import { motion } from 'framer-motion';

export default function WarningMessage({
    warningMessage,
    setWarningMessage,
    fullMessage
}) {
    useEffect(() => {
        const timer = setTimeout(() => {
            setWarningMessage('')
        }, 7000);

        return () => {
            clearTimeout(timer);
        };
    }, []);
    return (
        <>
            <div class="mb-3 absolute items-center w-fit top-[8px] left-[50%] -translate-x-[50%] z-[9999] shadow-s2 rounded-lg data-[te-alert-show]:inline-flex warning-msg" role="alert" data-te-alert-init="" data-te-alert-dismiss="" aria-label="Close">
                <motion.div
                    initial={{ y: -1000 }}
                    animate={{ y: 0 }}
                    transition={{ duration: 1 }}
                    exit={{ opacity: 0.5 }}
                    onClick={()=>{setWarningMessage('')}}
                    
                >
                    <div class="flex items-center justify-center border-[1.5px] border-[#FFA800] bg-[#FFEEB0] rounded-[7px] cursor-pointer px-5 py-[18px]">
                        <span>
                            <img loading="lazy" decoding="async" src="/images/warning-yellow.svg" alt="icon"/>
                        </span>
                        <p class="text-f1 text-[#000000] font-normal pl-5 g">{(fullMessage !== undefined && fullMessage === true) ? warningMessage : `Maximum of 20 ${warningMessage} can be uploaded at a time.`}</p>
                    </div>
                </motion.div>
            </div>
        </>
    )
}
